import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import InfoRow from "../InfoRow";
import { useAppContext } from "../../_context";
import Button from "../Misc/Button";
import CommonInfo from "./CommonInfo";

const MatchInfo = ({ match }) => {
  const [{ tx }] = useAppContext();

  return (
    <section className="section-padding-bottom">
      <Container>
        <Row>
          <Col md={6} className="mx-auto">
            <CommonInfo entity={match} />

            {match.description ? (
              <InfoRow icon="edit" label={tx["Notes"]}>
                {match.description}
              </InfoRow>
            ) : null}

            <Button href={`racketpal://matches/${match.id}`} className="w-100">
              {tx["See more info"]}
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default MatchInfo;
